"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DesktopHeader = _interopRequireDefault(require("./components/DesktopHeader"));

var _MobileHeader = _interopRequireDefault(require("./components/MobileHeader"));

var _PageShade = _interopRequireDefault(require("./components/PageShade"));

var _SearchBar = _interopRequireDefault(require("./components/Search/SearchBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
	headers need to be configured as follows:
	header: {
		links: [
			{
				link: 'string', // url/path to page
				label: 'string', // label that will be displayed
				showAuth: [true, true], // show link in respectively unauth and auth state
				icon: 'string', // icon name, shows the link as an icon only for desktop view
				mobileBar: false, // show link in bar in mobile view
				mobileIcon: 'string', // icon name, shows the link as an icon only for mobile view when set mobileBar is true
			}
		],
		search: {
			showAuth: [true, false], // show / hide link in respectively unauth and auth state
			searchApi: 'string', // Search API
			searchService: 'Services that call the API and retrieve search results'
			searchPageUrl: 'string' // path to redirect to to see all search items
		},
		phone: {
			showAuth: [false, true], // hide / show link in respectively unauth and auth state
			number: 'string', Number to display
		},
		login: {
			showAuth: [true, true], // show link in respectively unauth and auth state
			loginPath: 'string', // Login Path
			logoutPath: 'string', // Logout Path
		},
	}
 **/
var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_toggleScroll", function (val) {
      if (val) {
        document.body.classList.add('has-no-scroll');
      } else {
        document.body.classList.remove('has-no-scroll');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleSearch", function (val) {
      _this._toggleScroll(val);

      _this.setState({
        isSearching: val
      });
    });

    _this.state = {
      isSearching: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          homePath = _this$props.homePath,
          title = _this$props.title,
          auth = _this$props.auth;
      var isSearching = this.state.isSearching;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DesktopHeader.default, {
        header: header,
        homePath: homePath,
        title: title,
        auth: auth,
        toggleSearch: this._toggleSearch.bind(this),
        isSearching: isSearching
      }), /*#__PURE__*/_react.default.createElement(_MobileHeader.default, {
        header: header,
        homePath: homePath,
        title: title,
        auth: auth,
        toggleSearch: this._toggleSearch.bind(this),
        isSearching: isSearching
      }), isSearching && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SearchBar.default, {
        header: header,
        onClose: this._toggleSearch.bind(this, false)
      }), /*#__PURE__*/_react.default.createElement(_PageShade.default, {
        isActive: isSearching,
        toggleSearch: this._toggleSearch.bind(this)
      })));
    }
  }]);

  return Header;
}(_react.default.Component);

exports.default = Header;

_defineProperty(Header, "propTypes", {
  auth: _propTypes.default.object.isRequired,
  homePath: _propTypes.default.string.isRequired,
  header: _propTypes.default.object.isRequired,
  title: _propTypes.default.string.isRequired
});
//# sourceMappingURL=Header.js.map